import React from 'react';
import { InfoCircleIcon } from '@fiverr-private/visuals';
import { Tooltip } from '@fiverr-private/tooltip';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { useTemplatesData } from '../../hooks';

const TRANSLATION_PREFIX = 'legal_documents_package.seller_templates.empty_state';
const WITH_TEMPLATES_KEY = `${TRANSLATION_PREFIX}.with_templates`;
const NO_TEMPLATES_KEY = `${TRANSLATION_PREFIX}.no_templates`;

export interface LegalDocumentsTooltipProps {
    totalTemplates?: number;
    compact?: boolean;
}

const TOOLTIP_BREAKPOINT = 'md';

export const LegalDocumentsTitleDescription = ({ totalTemplates, compact }: LegalDocumentsTooltipProps) => {
    const { templatesQuery } = useTemplatesData();
    const totalTemplatesCount = templatesQuery?.data ? templatesQuery.data.length : totalTemplates;
    const translationKey = `${totalTemplatesCount ? WITH_TEMPLATES_KEY : NO_TEMPLATES_KEY}.description`;
    return (
        <>
            <Container
                display={compact ? 'inlineFlex' : { [TOOLTIP_BREAKPOINT]: 'none', default: 'inlineFlex' }}
                lineHeight="b_xxs"
                alignItems="center"
            >
                <Tooltip
                    position="bottom"
                    content={
                        <Typography size="b_sm">
                            <I18n k={translationKey} />
                        </Typography>
                    }
                    appendToBody
                >
                    <InfoCircleIcon size="sm" color="grey_800" />
                </Tooltip>
            </Container>
            <Container
                display={compact ? 'none' : { default: 'none', [TOOLTIP_BREAKPOINT]: 'inlineFlex' }}
                alignItems="center"
                overflow="hidden"
            >
                <Typography
                    as="span"
                    size={
                        compact
                            ? 'b_sm'
                            : {
                                  default: 'b_sm',
                                  sm: 'b_md',
                              }
                    }
                    overflow="hidden"
                    color="grey_900"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                >
                    <I18n k={translationKey} />
                </Typography>
            </Container>
        </>
    );
};
